module.exports = __webpack_public_path__ + "img/CH.95b9ca55.png";